import Vue from 'vue'

import Base from '../common/instance.base'
import DialogVue from './Slide.vue'
// eslint-disable-next-line camelcase
import { _width } from '@/utils/global'
import { getGoodDefaultImg } from '@/utils/utils'

const Slide = new Base('slide', Vue.extend(DialogVue))

Slide.open = function (options) {
  let op = Object.assign(
    {},
    {
      imgArr: [],
      isSaveImg: false
    },
    options
  )

  let { imgArr, activeIndex, isSaveImg, commonWaterMark = true } = op
  let size = imgArr.length
  if (imgArr.length === 0) {
    size = 1
    imgArr = [getGoodDefaultImg()]
  }
  let copyList = imgArr.slice(0)
  copyList = copyList.slice(-1).concat(copyList).concat(copyList.slice(0, 1))

  op = {
    imgArr,
    size,
    copyList,
    activeIndex: activeIndex || 0,
    tmpIndex: 0,
    width: _width,
    isSaveImg: isSaveImg,
    commonWaterMark: commonWaterMark,
    option: {
      auto: false,
      loop: true,
      scale: 1,
      spaceBetween: 0,
      allowTouchMove: true,
      appendNum: 1,
      speed: 600,
      delay: 3000,
      preventDefault: true,
      // eslint-disable-next-line camelcase
      startPos: -_width,
      // eslint-disable-next-line camelcase
      endPos: -_width * size
    }
  }

  return this.init(op)
}

Slide.close = function () {
  this.closeInstance()
}

Vue.$Slide = Vue.prototype.$Slide = Slide

// eslint-disable-next-line import/no-default-export
export default Slide
